// src/components/ui/Skeleton.jsx
import React from "react";

export default function Skeleton({ className = "" }) {
  return (
    <div className={`animate-pulse bg-secondary-700 rounded ${className}`} />
  );
}
